/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderListItemUpdateRequest } from '../../models/order-list-item-update-request';

export interface UpdateCurrentOrderListItemQuantity$Params {
  itemId: string;
      body: OrderListItemUpdateRequest
}

export function updateCurrentOrderListItemQuantity(http: HttpClient, rootUrl: string, params: UpdateCurrentOrderListItemQuantity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateCurrentOrderListItemQuantity.PATH, 'put');
  if (params) {
    rb.path('itemId', params.itemId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateCurrentOrderListItemQuantity.PATH = '/order-lists/current/items/{itemId}';
